import { render, staticRenderFns } from "./MixConfig.vue?vue&type=template&id=6e8a6810"
import script from "./MixConfig.vue?vue&type=script&lang=js"
export * from "./MixConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports